// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._2rko12b0{border-radius:var(--ds-radius-small,4px)}._1bah1h6o{justify-content:center}\n._1bsb1gwv{width:360px}\n._1e0c1txw{display:flex}\n._4cvr1h6o{align-items:center}\n._4t3i16xz{height:6pc}\n._kqswh2mm{position:relative}", ""]);
// Exports
module.exports = exports;
